'use client'

import { useEffect, useState } from 'react'

import Lottie from 'lottie-react'

import booksLoadingAnimation from '@/shared/assets/animations/books-loading.json'

const BOOTSTRAP_MESSAGES = [
  'Preparando sua jornada empreendedora...',
  'Organizando missões e desafios...',
  'Carregando novas oportunidades...',
  'Calculando pontos de experiência...',
  'Destravando conquistas incríveis...',
  'Montando seu próximo desafio...',
  'Reunindo ferramentas para sua próxima ideia...',
  'Ajustando o ranking dos jovens empreendedores...'
]

const MESSAGE_ROTATION_MS = 3200

export function BootstrapLoadingOverlay() {
  const [messageIndex, setMessageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % BOOTSTRAP_MESSAGES.length)
    }, MESSAGE_ROTATION_MS)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div
      className="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-background/95 px-6 backdrop-blur-sm"
      aria-busy="true"
      aria-live="polite"
      aria-label="Carregando a plataforma"
    >
      <div className="w-48 shrink-0 sm:w-56">
        <Lottie
          animationData={booksLoadingAnimation}
          loop
          role="img"
          aria-hidden="true"
        />
      </div>
      <p
        className="mt-6 max-w-sm text-center text-sm font-medium text-white transition-opacity duration-300"
        key={messageIndex}
      >
        {BOOTSTRAP_MESSAGES[messageIndex]}
      </p>
    </div>
  )
}
